import localKey from "./localKey";

const devApiUrl = "/";

// const proApiUrl = "http://dev.ops.fxzb.vip";
// const proApiUrl = "http://192.168.110.201:8208";
const proApiUrl = "https://ops.api.fxzb.vip";
const nodeDevEnv = process.env.NODE_ENV == "development" ? true : false;

export default {
  nodeDevEnv: nodeDevEnv,
  apiUrl: nodeDevEnv ? devApiUrl : proApiUrl,
  siteName: "百米赛跑运维中心后台",
  minSiteMame: "C",
  version: "v1.0.0",
  apiPrefix: "",
  timeout: 60000,
  cookiesExpires: 7,
  requestRetry: 3,
  requestRetryDelay: 800,
  tokenKey: "Authorization",
  userInfoKey: "USER_INFO",
  ...localKey,
};
